"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var Radio =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Radio, _Component);

  function Radio() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Radio);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Radio)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onInvalid", function (evt) {
      evt.preventDefault();
      var onValidationChange = _this.props.onValidationChange;

      if (onValidationChange) {
        onValidationChange(evt.currentTarget.validity);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onChange", function (evt) {
      var _this$props = _this.props,
          onValidationChange = _this$props.onValidationChange,
          onChange = _this$props.onChange;

      if (onValidationChange) {
        onValidationChange();
      }

      if (onChange) {
        onChange(evt);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(Radio, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._input.addEventListener('invalid', this._onInvalid);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._input.removeEventListener('invalid', this._onInvalid);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          label = _this$props2.label,
          className = _this$props2.className,
          name = _this$props2.name,
          value = _this$props2.value,
          defaultChecked = _this$props2.defaultChecked,
          disabled = _this$props2.disabled,
          required = _this$props2.required,
          id = _this$props2.id;
      var classes = (0, _classnames.default)('Radio', 'FormElement', className);
      return _react.default.createElement("div", {
        className: classes
      }, _react.default.createElement("input", {
        ref: function ref(node) {
          _this2._input = node;
        },
        className: "FormElement-item",
        id: "Radio-".concat(id),
        type: "radio",
        name: name,
        value: value,
        defaultChecked: defaultChecked,
        onChange: this._onChange,
        disabled: disabled,
        required: required
      }), (0, _react.cloneElement)(label, {
        htmlFor: "Radio-".concat(id)
      }));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return Radio;
}(_react.Component);

exports.default = Radio;
(0, _defineProperty2.default)(Radio, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** The name for which the chosen value will correspond. Automatically passed from RadioGroup, do not set manually.
   *
   * @ignore
   */
  name: _propTypes.default.string,

  /** A value which is used when this radio is selected. */
  value: _propTypes.default.string,

  /** A custom label (typically a Label component) to display next to the radio. */
  label: _propTypes.default.element.isRequired,

  /** Whether the radio should be checked on mount. */
  defaultChecked: _propTypes.default.bool,

  /** Whether the element is disabled. Automatically passed from RadioGroup, do not set manually.
   *
   * @ignore
   */
  disabled: _propTypes.default.bool,

  /** Whether the element is required. Automatically passed from RadioGroup, do not set manually.
   *
   * @ignore
   */
  required: _propTypes.default.bool,

  /** The unique identifier to ensure this Radio is part of the right RadioGroup. Automatically passed from RadioGroup, do not set manually.
   *
   * @ignore
   */
  id: _propTypes.default.string,

  /**
   * Method called when an item is checked. Automatically passed from RadioGroup, do not set manually.
   *
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * Method called when validation state changes. Automatically passed from RadioGroup, do not set manually.
   *
   * @ignore
   */
  onValidationChange: _propTypes.default.func
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Radio, "Radio", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Radio/Radio.jsx");
  leaveModule(module);
})();

;